/**
 * ClarifyEvent — renderiza tipo 'clarify'
 * payload: { pregunta, opciones?[] }
 * R-PT-07: pausa-y-pregunta (gate de ambigüedad).
 * El usuario responde con un mensaje normal; las opciones son atajos.
 */

export default function ClarifyEvent({ payload, onReply }) {
  const { pregunta, opciones = [] } = payload

  return (
    <div className="event-clarify">
      <p className="event-clarify__question">{pregunta}</p>
      {opciones.length > 0 && (
        <div className="event-clarify__options">
          {opciones.map((opt, i) => (
            <button
              key={i}
              className="clarify-option"
              onClick={() => onReply?.(opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
